import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardMedia, Skeleton, Stack, Typography } from '@mui/material';
import Slider from 'react-slick'; // Import the Slider component from react-slick
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// Import icons from Material-UI Icons

import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllBrands } from '../../../server/api/vehicle';
import { useDevice } from '../../../hooks/useResponsive';

Brands.propTypes = {
  addMargin: PropTypes.any,
};
export default function Brands() {
  const { isMobile } = useDevice();
  const dispatch = useDispatch();
  const [currentSlide, setCurrentSlide] = useState(0);

  const { brands, loading } = useSelector((state) => ({
    brands: state.vehicle.brands?.response,
    loading: state.vehicle.loading,
  }));

  useEffect(() => {
    const credentials = {
      dispatch,
      page: 1,
      limit: 30,
      searchText: '',
    };
    dispatch(getAllBrands(credentials));
  }, [dispatch]);

  // Custom left arrow component
  // const CustomPrevArrow = (props) => {
  //   // eslint-disable-next-line react/prop-types
  //   const { onClick } = props;
  //   return (
  //     <div
  //       className="arrow arrow-left LeftArrow arrow-left-brand"
  //       role="button"
  //       tabIndex="0"
  //       onClick={onClick}
  //       onKeyDown={(e) => {
  //         if (e.key === 'Enter') onClick();
  //       }}
  //     >
  //       <ArrowBackIcon fontSize="small" /> {/* Use the ChevronLeftIcon from Material-UI Icons */}
  //     </div>
  //   );
  // };

  // Custom right arrow component
  // const CustomNextArrow = (props) => {
  //   // eslint-disable-next-line react/prop-types
  //   const { onClick } = props;
  //   return (
  //     <div
  //       className="arrow arrow-right RighrArrow arrow-right-brand"
  //       role="button"
  //       tabIndex="0"
  //       onClick={onClick}
  //       onKeyDown={(e) => {
  //         if (e.key === 'Enter') onClick();
  //       }}
  //     >
  //       <ArrowForwardIcon fontSize="small" /> {/* Use the ChevronRightIcon from Material-UI Icons */}
  //     </div>
  //   );
  // };

  // Configuration for the carousel
  const slideCount = brands?.brands.length;

  const CustomPrevArrow = ({ onClick, currentSlide }) => {
    if (currentSlide === 0) return null; // hide on first slide

    return (
      <Stack
        role="button"
        tabIndex="0"
        onClick={onClick}
        onKeyDown={(e) => e.key === 'Enter' && onClick()}
        sx={{
          // backgroundColor: 'rgba(100, 100, 100, 0.9)',
          borderRadius: '50%',
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          position: 'absolute',
          left: 14,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 2,
          transition: 'background-color 0.3s ease',
          '&:hover': {
            // backgroundColor: 'rgba(80, 80, 80, 0.9)',
          },
        }}
      >
        <ChevronLeftIcon sx={{ fontSize: 30, color: 'white' }} />
      </Stack>
    );
  };
  CustomPrevArrow.propTypes = {
    onClick: PropTypes.func,
    currentSlide: PropTypes.number.isRequired,
  };
  const CustomNextArrow = ({ onClick, currentSlide, slideCount, slidesToShow }) => {
    if (currentSlide >= slideCount - slidesToShow) return null; // hide if no more slides ahead

    return (
      <Stack
        role="button"
        tabIndex="0"
        onClick={onClick}
        onKeyDown={(e) => e.key === 'Enter' && onClick()}
        sx={{
          // backgroundColor: 'rgba(100, 100, 100, 0.9)',
          borderRadius: '50%',
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          position: 'absolute',
          right: -14,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 2,
          transition: 'background-color 0.3s ease',
          '&:hover': {
            // backgroundColor: 'rgba(80, 80, 80, 0.9)',
          },
        }}
      >
        <ChevronRightIcon sx={{ fontSize: 30, color: 'white' }} />
      </Stack>
    );
  };
  CustomNextArrow.propTypes = {
    onClick: PropTypes.func,
    currentSlide: PropTypes.number.isRequired,
    slideCount: PropTypes.number.isRequired,
    slidesToShow: PropTypes.number.isRequired,
  };
  const STS = isMobile ? 5.6 : 8;

  const carouselSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: STS,
    slidesToScroll: isMobile ? 3 : 1,
    arrows: !isMobile && true,
    prevArrow: <CustomPrevArrow currentSlide={currentSlide} />,
    nextArrow: <CustomNextArrow currentSlide={currentSlide} slideCount={slideCount} slidesToShow={STS} />,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
  };

  // const brands = [
  //   { name: 'Suzuki', image: '/assets/images/Home/suzuki.png' },
  //   { name: 'Hyundai', image: '/assets/images/Home/hyundai.png' },
  //   { name: 'Mahindra', image: '/assets/images/Home/mahindra.png' },
  //   { name: 'Toyota', image: '/assets/images/Home/toyota.png' },
  //   { name: 'Tata', image: '/assets/images/Home/tata.png' },
  //   { name: 'Honda', image: '/assets/images/Home/honda.png' },
  //   { name: 'Ford', image: '/assets/images/Home/ford.png' },
  //   { name: 'Renault', image: '/assets/images/Home/renault.png' },
  //   { name: 'Volkswagen', image: '/assets/images/Home/wolks.png' },
  // ];

  return (
    <>
      <Stack
        className="main-banner"
        sx={{
          pb: isMobile ? 4 : 3,
          pr: isMobile ? '0px !important ' : '75px',
          pl: isMobile ? 0.8 : '63px !important',
          pt: !isMobile && 8,
        }}
      >
        {/* <Typography
          className="featured-text"
          color={isMobile ? '#e0e0e0' : '#e0e0e0'}
          fontSize={isMobile ? '14px' : '14px'}
          fontWeight="bolder"
          pb={isMobile ? 1 : 4}
          pt={isMobile && 3}
          pl={isMobile ? 1.8 : 0}
          textAlign={!isMobile && 'center'}
          justifyContent={!isMobile && 'center'}
        >
          Select by Brand
        </Typography> */}
        <Stack>
          <Box
            sx={{
              zIndex: 100,
              overflowX: 'hidden',
              '& .slick-slide > div': {
                py: !isMobile && 1.5,
                px: isMobile ? 0.5 : 2, // 8px horizontal padding between slides (adjust as needed)
              },
              '& .slick-slide': {
                overflow: 'visible', // allow individual slides to overflow on hover
              },
              '& .slick-list': {
                overflow: 'hidden', // ✅ keep this hidden to avoid horizontal overflow
              },
              // mx: '-8px', // counter negative margin to keep slider aligned
            }}
          >
            {loading ? (
              <Slider {...carouselSettings}>
                {[...Array(isMobile ? 6 : 9)].map((_, index) => (
                  <Stack
                    key={index}
                    sx={{
                      backgroundColor: '#1e1e1e',
                      padding: isMobile ? '8px' : '15px',
                      borderRadius: '8px',
                      mx: 1.5,
                    }}
                  >
                    <Card className="CardTransform brand">
                      <Skeleton variant="rectangular" height={isMobile ? 25 : 60} sx={{ bgcolor: '#2a2a2a' }} />
                    </Card>
                    <Skeleton width="60%" height={12} sx={{ mt: 1, mx: 'auto', bgcolor: '#2a2a2a' }} />
                  </Stack>
                ))}
              </Slider>
            ) : brands?.brands && brands.brands.length > 0 ? (
              <Slider {...carouselSettings}>
                {brands?.brands?.map((brand, key) => (
                  //                 <Link to={`/allproducts?id=${brand?._id}`} key={key} style={{ display: 'block',
                  // width: '100%',
                  // textDecoration: 'none', // no underline
                  // color: 'inherit',  }}>
                  <Stack
                    key={key}
                    sx={{
                      backgroundColor: '#1e1e1e',
                      padding: isMobile ? '8px' : '15px',
                      borderRadius: '8px',
                      mx: 1.5,
                      transition: 'all 0.3s ease',
                      overflow: 'hidden',
                      position: 'relative',
                      cursor: 'pointer',
                      // maxHeight: isMobile && '60px',
                      // ...(isMobile
                      //   ? {}
                      //   : {
                      //       '&:hover': {
                      //         transform: 'scale(1.08)',
                      //         boxShadow: '0 4px 10px rgba(0,0,0,0.5)',
                      //         border: '1.11px solid',
                      //         borderImageSource: 'linear-gradient(180deg, #CBCBCB 0%, #3E3E3E 11.07%, #999999 100%)',
                      //         borderImageSlice: 1,
                      //         borderRadius: '8px',
                      //       },
                      //     }),
                      ...(isMobile
                        ? {}
                        : {
                            '&:hover': {
                              transform: 'scale(1.2)',
                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                borderRadius: '8px',
                                cursor: 'pointer',

                                padding: '1px', // border thickness
                                background: 'linear-gradient(180deg, #CBCBCB 0%, #3E3E3E 11.07%, #999999 100%)',
                                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                WebkitMaskComposite: 'destination-out',
                                maskComposite: 'exclude',
                                pointerEvents: 'none',
                                zIndex: 1,
                              },
                            },
                          }),
                    }}
                  >
                    {brand && brand?.logo && (
                      // <Link to={`/allproducts?id=${brand?._id}`}>
                      <Link to={`/allproducts?brands=${brand?._id}`} key={key}>
                        <Card className="CardTransform brand">
                          <CardMedia
                            component="img"
                            className=""
                            src={brand?.logo[0]?.url}
                            alt="Card Image"
                            height={isMobile ? 25 : 50}
                            sx={{ objectFit: 'contain', backgroundColor: '#1e1e1e' }}
                          />
                        </Card>
                      </Link>
                    )}
                    <Link to={`/allproducts?brands=${brand?._id}`} style={{ textDecoration: 'unset' }}>
                      <Typography
                        sx={{
                          color: '#e0e0e0',
                          fontWeight: 400,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                        textAlign={'center'}
                        pt={isMobile ? 0.5 : 1.3}
                        fontSize={isMobile ? 10 : 13}
                      >
                        {/* {brand?.name} */}
                        {isMobile
                          ? brand?.name?.length > 9
                            ? `${brand.name.slice(0, 9)}...`
                            : brand?.name
                          : brand?.name}
                      </Typography>
                    </Link>
                  </Stack>
                  // </Link>
                ))}
              </Slider>
            ) : (
              <Typography sx={{ textAlign: 'center', color: '#999', py: 3, fontSize: 14 }}>
                No brand added yet
              </Typography>
            )}
          </Box>
          {/* {!isMobile && (
              <Box display={'flex'} justifyContent={'center'} mt={5}>
                <Link to={'/allproducts'} style={{ textDecoration: 'none' }}>
                  <Button className="all-brand-btn" sx={{ px: 6 }}>
                    VIEW ALL CARS
                  </Button>
                </Link>
              </Box>
            )} */}
        </Stack>
      </Stack>
    </>
  );
}
